<template>
    <div class="o-news">
        <div class="container">
            <div class="o-news__header pt-3 pb-3 pb-md-0">
                <div class="row align-items-center">
                    <div class="col-4 order-1">
                        <bread-crumbs
                            defaultUrl="newsletters"
                            :forceDefaultUrl="true"
                        />
                    </div>
                </div>
            </div>
            <page-preloader
                min-height="38vh"
                :is-loading="true"
                v-if="status === 'loading'"
            />
            <template v-else-if="isNewsletter">
                <div class="o-newsletterGrid__elContent pt-2 pl-3 pr-3 pb-3">
                    <img
                        class="img-fluid w-100 mb-3"
                        :src="newsletter.graphicsLink"
                        alt=""
                    />
                    <h2
                        class="o-newsletterGrid__elMainTitle"
                        v-html="newsletter.title"
                    />
                    <p class="o-newsletterGrid__elDate mb-1">
                        {{
                            $moment(
                                newsletter.publicationDate,
                                'DD-MM-YYYY HH:mm'
                            ).format('DD-MM-YYYY, HH:mm')
                        }}
                    </p>
                    <p
                        class="o-newsletterGrid__elContent"
                        v-html="newsletter.content"
                    />
                    <div
                        class="o-newsletterGrid__attachments my-5"
                        v-if="areAttachments"
                    >
                        <h5 class="mb-3">Załączniki:</h5>
                        <promotion-slider
                            :data="attachmentsMap"
                            :responsive="{
                                120: {
                                    items: 1
                                },
                                400: {
                                    items: 2
                                },
                                520: {
                                    items: 3
                                },
                                620: {
                                    items: 4
                                },
                                768: {
                                    items: 3
                                },
                                900: {
                                    items: 4
                                },
                                1100: {
                                    items: 5
                                },
                                1420: {
                                    items: 6
                                }
                            }"
                        />
                    </div>
                </div>
                <div
                    class="o-newsletterGrid__offeredNews p-3"
                    v-if="offeredNews && offeredNews.length"
                >
                    <h5 class="mb-3 mt-5">Zobacz także</h5>
                    <newsletter-grid
                        type="list"
                        class="fetch-more mb-5"
                        :list="offeredNews"
                        show-new-badge
                    />
                </div>
            </template>
            <div class="mt-3 mb-5" style="min-height: 35vh;" v-else>
                Brak wyników
            </div>
        </div>
    </div>
</template>

<script>
import PromotionSlider from '@/components/promotions/PromotionSlider'
import NewsletterGrid from '@/components/newsletters/NewsletterGrid.vue'

export default {
    components: {
        PromotionSlider,
        NewsletterGrid
    },
    data() {
        return {
            currentId: null,
            offeredNewsCount: null
        }
    },
    async created() {
        this.currentId = this.$route.params.id
        await this.fetch()
        window.addEventListener('resize', () => {
            this.setOfferedNewsCount()
        })
        this.$nextTick(() => {
            this.setOfferedNewsCount()
        })
        this.$store.dispatch('markNewsletterAsRead', {
            id: this.currentId,
            unread: false
        })
    },
    watch: {
        offeredNewsCount: {
            handler() {
                this.fetchOfferedNewsCount()
            }
        }
    },
    computed: {
        newsletters() {
            return this.$store.getters.getNewsletters
        },
        offeredNews() {
            return this.newsletters
                ?.filter(el => el.id !== Number(this.currentId))
                .splice(0, this.offeredNewsCount)
        },
        newsletter() {
            return this.$store.getters.getNewsletterDetails
        },
        isNewsletter() {
            return this.newsletter
        },
        status() {
            return this.$store.getters.getNewsletterDetailsStatus
        },
        areAttachments() {
            return this.newsletter.attachments?.length > 0
        },
        attachmentsMap() {
            return this.newsletter.attachments.map(el => {
                return {
                    name: el.name,
                    fileName: el.fileName,
                    urls: {
                        original: el.link
                    }
                }
            })
        }
    },
    methods: {
        fetch() {
            if (this.currentId) {
                return this.$store.dispatch('loadNewsletterDetails', {
                    newsId: this.currentId
                })
            } else {
                this.$router.push({ name: 'newsletters' })
            }
        },
        setOfferedNewsCount() {
            if (window.innerWidth < 575) {
                this.offeredNewsCount = 4
            } else if (window.innerWidth < 768) {
                this.offeredNewsCount = 3
            } else if (window.innerWidth < 992) {
                this.offeredNewsCount = 4
            } else {
                this.offeredNewsCount = 5
            }
        },
        fetchOfferedNewsCount() {
            this.$store.dispatch('loadNewsletters', {
                limit: this.offeredNewsCount + 1,
                offset: 0,
                archival: false
            })
        }
    }
}
</script>
